import { render } from "./RXform.vue?vue&type=template&id=2e3572ff&scoped=true"
import script from "./RXform.vue?vue&type=script&lang=js"
export * from "./RXform.vue?vue&type=script&lang=js"

import "./RXform.vue?vue&type=style&index=0&id=2e3572ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3572ff"]])

export default __exports__